import { createSelector } from "reselect"
import { IBreadcrumbInfo, IHeader } from "./index"
import { IButton } from "../common/contextmenu"

const getBreadcrumbs = (state: IHeader): Record<string, IBreadcrumbInfo> =>
    state.breadcrumbs

export interface SortedBreadcrumbs {
    sortedBreadcrumbs: IBreadcrumbInfo[]
}

export const getSortedBreadcrumbs = createSelector(
    [getBreadcrumbs],
    (breadcrumbs): IBreadcrumbInfo[] =>
        Object.values(breadcrumbs).sort((a, b) => a.index - b.index),
)

const getButtons = (state: IHeader): Record<string, IButton> => state.buttons

export interface SeparatedButtons {
    optionalCustomButtons: Record<string, IButton>
    optionalStandardButtons: Record<string, IButton>
    visibleCustomButtons: Record<string, IButton>
    visibleStandardButtons: Record<string, IButton>
}

export const getSeparatedButtonsByVisibility = createSelector(
    [getButtons],
    (buttons): SeparatedButtons => {
        const optionalCustomButtons: Record<string, IButton> = {}
        const optionalStandardButtons: Record<string, IButton> = {}
        const visibleCustomButtons: Record<string, IButton> = {}
        const visibleStandardButtons: Record<string, IButton> = {}

        for (const key in buttons) {
            const button = buttons[key]

            if (button.inOptionalMenu) {
                if (button.isCustom) {
                    optionalCustomButtons[button.uuid] = button
                } else {
                    optionalStandardButtons[button.uuid] = button
                }
            } else if (button.isCustom) {
                visibleCustomButtons[button.uuid] = button
            } else {
                visibleStandardButtons[button.uuid] = button
            }
        }

        return {
            optionalCustomButtons,
            optionalStandardButtons,
            visibleCustomButtons,
            visibleStandardButtons,
        }
    },
)
